import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useShipmentContext } from '../../../../components/ShipmentProvider/ShipmentProvider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Property from '@afosto/app-components-react/Property';
import { datetime as datetimeFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const ShipmentInfoSection = () => {
  const intl = useIntl();
  const { shipment } = useShipmentContext();

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Property
          label={intl.formatMessage(translations.properties.expectedAt)}
          value={datetimeFormatter(shipment?.expected_at)}
        />
        <Property
          label={intl.formatMessage(translations.properties.expectedShipAt)}
          value={datetimeFormatter(shipment?.expected_ship_at)}
        />
        <Property
          label={intl.formatMessage(translations.properties.shipAt)}
          value={datetimeFormatter(shipment?.ship_at)}
        />
        <Property
          label={intl.formatMessage(translations.properties.createdAt)}
          value={datetimeFormatter(shipment?.created_at)}
        />
        <Property
          label={intl.formatMessage(translations.properties.updatedAt)}
          value={datetimeFormatter(shipment?.updated_at)}
        />
      </CardContent>
    </Card>
  );
};

export default ShipmentInfoSection;
